import {
    Col,
    Container,
    Form,
    Modal,
    Row,
    Table,
    Button
} from "react-bootstrap";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { ThreeDotSpinner } from "../loader";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const ProfileQuestionManagement = () => {

    const [page, setPage] = useState(0);
    const [items, setItems] = useState(null);
    const [loader, setLoader] = useState(false);

    const [showModal, setShowModal] = useState(false); 
    const [editingItem, setEditingItem] = useState(null);

    const [formData, setFormData] = useState({
        question: "",
        options: ["", ""],
        order: 1
    });

    useEffect(() => {
        getProfileQuestions(page);
    }, []);

    async function getProfileQuestions(page) {
        setLoader(true);
        try {
            const response = await apiService.getAllProfileQuestions( page );

            if (response?.status === 200) {
                setItems(response.data.data);
            }

        } catch (error) {
            swal("Error", error?.response?.data?.message || error.message, "error");
        } finally {
            setLoader(false);
        }
    }

    function handlePageChange(pageNumber) {

        setPage(pageNumber-1);
        getProfileQuestions(pageNumber-1);
    }

    function openModal(item = null) {
        if (item) {
            setEditingItem(item);
            setFormData({
                question: item.question,
                options: item.options,
                order: item.order
            });
        } else {
            setEditingItem(null);
            setFormData({
                question: "",
                options: ["", ""],
                order: 1
            });
        }
        setShowModal(true);
    }

    function handleOptionChange(index, value) {
        const updatedOptions = [...formData.options];
        updatedOptions[index] = value;
        setFormData({ ...formData, options: updatedOptions });
    }

    function addOptionField() {
        if (formData.options.length >= 5) return;
        setFormData({ ...formData, options: [...formData.options, ""] });
    }

    async function handleSubmit() {
        try {
            // Basic validations
            const trimmedQuestion = formData.question.trim();
            if (!trimmedQuestion) {
                swal("Error", "Question is required.", "error");
                return;
            }

            const cleanedOptions = formData.options
                .map((opt) => opt.trim())
                .filter((opt) => opt.length > 0);

            if (cleanedOptions.length < 2) {
                swal("Error", "Please provide at least 2 options.", "error");
                return;
            }

            const orderNum = Number(formData.order);

            if (!Number.isInteger(orderNum) || orderNum <= 0) {
                swal("Error", "Display order must be a positive number.", "error");
                return;
            }

            const existingQuestions = items?.questions || [];
            const existingOrders = existingQuestions
                .filter((q) => !editingItem || q._id !== editingItem._id)
                .map((q) => q.order);

            if (existingOrders.includes(orderNum)) {
                swal(
                    "Error",
                    "Display order must be unique. Another question already uses this order number.",
                    "error"
                );
                return;
            }

            setLoader(true);

            const payload = {
                question: trimmedQuestion,
                options: cleanedOptions,
                order: orderNum
            };

            if (editingItem) {
                await apiService.updateProfileQuestion(editingItem._id, payload);
                swal("Success", "Profile Question Updated", "success");
            } else {
                await apiService.createProfileQuestion(payload);
                swal("Success", "Profile Question Created", "success");
            }

            setShowModal(false);
            getProfileQuestions(page);

        } catch (error) {
            swal("Error", error?.response?.data?.message || error.message, "error");
        } finally {
            setLoader(false);
        }
    }

    async function toggleActive(item) {
        try {
            setLoader(true);
            let data = {
                isActive:item.isActive?false:true
            }
            await apiService.deactivateProfileQuestion(item._id);
            swal("Success", "Status Updated", "success");
            getProfileQuestions(page);
        } catch (error) {
            swal("Error", error?.response?.data?.message || error.message, "error");
        } finally {
            setLoader(false);
        }
    }

    return (
        <div className="dashboard-main-area">
            {loader && <ThreeDotSpinner />}
            <Container fluid>
            <div className="dashboard-area-heading management-heading">
                      <Row className="row justify-content-center align-items-center mb-3">
                        <Col md={12} lg={11}>
                            <div className="heading-top-area">
                                {/* <div className="profile-question"> */}
                                    <h2>Profile Question Management</h2>
                                    <div className="heading-top-area-right">
                                    <Button onClick={() => openModal()}>
                                        Add Question
                                    </Button>
                                    {/* </div> */}
                                </div>
                            </div>
                        </Col>
                    </Row>

               <Row className="pb-4 justify-content-center">
                        <Col md={12} lg={11}>
                        <div className="audit-request-box">
                                <Table  responsive="sm" className="UserListTable">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Question</th>
                                            <th>Options</th>
                                            <th>Order</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items?.questions?.length > 0 ? (
                                            items.questions.map((item, index) => {
                                                const serialNumber = (page - 1) * 10 + index + 1;
                                                return (
                                                    <tr key={item._id}>
                                                        <td>{index+1}</td>
                                                        <td>{item.question}</td>
                                                        <td>{item.options.join(", ")}</td>
                                                        <td>{item.order}</td>
                                                        <td>{item.isActive ? "Active" : "Inactive"}</td>
                                                        {/* <td>
                                                            <Button
                                                                size="sm"
                                                                onClick={() => openModal(item)}
                                                            >
                                                                Edit
                                                            </Button>{" "}
                                                            <Button
                                                                size="sm"
                                                                variant="warning"
                                                                onClick={() => toggleActive(item)}
                                                            >
                                                                Toggle
                                                            </Button>
                                                        </td> */}
                                                        <td>
                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}
                                                                >
                                                                    <i
                                                                        className="fa fa-pencil fa-lg"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => openModal(item)}
                                                                    ></i>
                                                                </OverlayTrigger>
                                                                <Form.Check
                                                                    type="switch"
                                                                    
                                                                    checked={item.isActive}
                                                                    className="by-bit-toggle"
                                                                    onChange={() => toggleActive(item)}
                                                                />

                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={6} className="text-center">
                                                    No data found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>

                                {items?.total > 10 && (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={10}
                                        totalItemsCount={items.total}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                    />
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>

            {/* Add/Edit Modal */}
          
            <Modal
                className="add-pediction-area"
                show={showModal}
                onHide={() => setShowModal(false)}
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {editingItem ? "Edit Question" : "Add Question"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="pb-3">
                    <div className="row row-cols-md-12">
                        <form>
                            {/* Question */}
                            <div className="mb-2">
                                <label className="form-label">
                                    Question <span>*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={formData.question}
                                    onChange={(e) =>
                                        setFormData({ ...formData, question: e.target.value })
                                    }
                                />
                            </div>

                            {/* Options */}
                            <div className="mb-2">
                                <label className="form-label">
                                    Options (max 5)
                                </label>

                                {formData.options.map((opt, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        className="form-control mb-2"
                                        value={opt}
                                        onChange={(e) =>
                                            handleOptionChange(index, e.target.value)
                                        }
                                    />
                                ))}

                                {formData.options.length < 5 && (
                                    <Button size="sm" onClick={addOptionField}>
                                        Add Option
                                    </Button>
                                )}
                            </div>

                            {/* Display Order */}
                            <div className="mb-2">
                                <label className="form-label">
                                    Display Order <span>*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="number"
                                    value={formData.order}
                                    onChange={(e) =>
                                        setFormData({ ...formData, order: e.target.value })
                                    }
                                />
                            </div>
                        </form>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleSubmit}>Save</Button>
                    <Button
                        className="close-btn-bottom"
                        onClick={() => setShowModal(false)}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
              {/* <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {editingItem ? "Edit Question" : "Add Question"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Question</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.question}
                                onChange={(e) =>
                                    setFormData({ ...formData, question: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Options (max 5)</Form.Label>
                            {formData.options.map((opt, index) => (
                                <Form.Control
                                    key={index}
                                    type="text"
                                    className="mb-2"
                                    value={opt}
                                    onChange={(e) =>
                                        handleOptionChange(index, e.target.value)
                                    }
                                />
                            ))}
                            {formData.options.length < 5 && (
                                <Button size="sm" onClick={addOptionField}>
                                    Add Option
                                </Button>
                            )}
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Display Order</Form.Label>
                            <Form.Control
                                type="number"
                                value={formData.order}
                                onChange={(e) =>
                                    setFormData({ ...formData, order: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal> */}
        </div>
    );
};
